import type { SystemSurfaceManifest } from "../contracts/system-surface";

export const createSurfaceManifest: SystemSurfaceManifest = {
  id: "create",
  title: "Create",
  load: () => import("./index"),
};
